import { Chord } from '../backingTrackGenerator/editorStore/backingTrackGeneratorEditorState'
import smartChords from './../assets/data/smart-chords-tree_6_0.02.json'
import { getChordDegreeIndex, getChordDegreeType, getScaleAllChords } from './TonalUtils'

// If i want to know if a certain chord progression exists just search for it in the .json as a string

// returns only 4 chords progressions
const findSuggestionsRec = (node: any, parentCount: number, currProb: number = 1) => {
  if (node.data.path.split('.').length > 4)
    return
  
  if (node.data.path.split('.').length === 4) {
    return {
      score: (node.data.count / parentCount) * currProb,// score parmis le noeud, peut être bien d'avoir aussi le score parmis tout l'arbre
      degrees: node.data.path.split('.')
    }
  }

  return node.children.flatMap((child: any) => findSuggestionsRec(child, node.data.count, (child.data.count / parentCount) * currProb))
}

const findSuggestions = (degrees: string[]) => {

  // Finds right node in tree
  let currNode: any = smartChords
  for (let i = 0; currNode && currNode.children && currNode.children.length > 0 && i < degrees.length; i++) {
    currNode = currNode.children.find((child: any) => child.data.SInED === degrees[i])    
  }

  if (!currNode) {
    console.log('SmartChord node not found: ', { degrees })
    return []
  }

  // console.log({ suggestions: findSuggestionsRec(currNode, currNode.data.count) })
  
  const suggestions: any = currNode ? findSuggestionsRec(currNode, currNode.data.count) : []

  return suggestions.sort((s1: any, s2: any) => s2.score - s1.score)
}

/*
  suggestion: {
    score: %,
    degrees: [],
    chords: [],
  }
*/

// chords.length should be < 4
export const getChordsSuggestions = (scale: string, chords: Chord[]) => {
  if (chords.some((c: Chord) => c.degreeName === undefined) || chords.length >= 4) return []// TODO : return suggestions even if one chord as no degree

  const degrees = chords.map((c: Chord) => (getChordDegreeIndex(c) + 1) + getChordDegreeType(c))

  // Filter out unknown degree notation 45, 5/7, ...
  // known are 4, 5, 57
  const suggestions = findSuggestions(degrees).filter((suggestion: any) => {
    // TODO : extend this .every test
    const ret = suggestion.degrees.every((degree: string) => (degree.length === 1 || degree.replace('7', '').length === 1) && degree[0] !== 'b' && degree[0] !== '#' && degree[0] !== 'L')
    
    if (!ret)
      console.log({ filteredOutSuggestion: suggestion })

    return ret
  })

  const scaleAllChords = getScaleAllChords(scale)

  return suggestions.map((suggestion: any) => ({
    ...suggestion,
    chords: suggestion.degrees.map((degree: string) => {
      if (degree.length > 1 && degree.includes('7')) {
        return scaleAllChords.seventh[parseInt(degree[0]) - 1]
      }
      else {
        return scaleAllChords.triad[parseInt(degree[0]) - 1]
      }
    })
  }))
}
